import axios from "axios"
import * as url from "./url_helper"
import { AES, enc } from 'crypto-js';

function base64ToBlob(base64String, contentType) {
  const sliceSize = 512;
  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}
export const downloadBase64File = (base64String, fileName, fileExtension, contentType) =>{
  const blob = base64ToBlob(base64String, contentType);
  const url = URL.createObjectURL(blob);
  const fullFileName = `hwa-${fileName}`;//`.${fileExtension}`;
  const a = document.createElement('a');
  a.href = url;
  a.download = fullFileName;
  a.click();
  URL.revokeObjectURL(url);
}
export const getContentTypeFromBase64 = (base64String) => {
  const matches = base64String.match(/^data:(.+);base64,/);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return null;
}


export const encryptId = (id) => {
  const secretKey = 'your-secret-key'; 
  const encryptedId = AES.encrypt(id.toString(), secretKey).toString();
  return encodeURIComponent(encryptedId);
}
export const decryptId = (encryptedId) => {
  const secretKey = 'your-secret-key'; 
  const decodedEncryptedId = decodeURIComponent(encryptedId);
  const decryptedId = AES.decrypt(decodedEncryptedId, secretKey).toString(enc.Utf8);
  return decryptedId;
}
export const truncate = (str) => {
  const words = str.split(' ');
  const truncatedWords = words.slice(0, 5);
  return truncatedWords.join(' ')+'...';
}
// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
export const postRegister = data => {
  return axios
    .post(url.USERS, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}


 export const dConfig = {
  auth: {
    username: process.env.REACT_APP_CM_US,
    password: process.env.REACT_APP_CM_PD,
  },
  headers: {
    'Content-Type': 'application/json'
  }
}
export const Config = {
  headers: {
    'Authorization': 'Basic ' + btoa(`${process.env.REACT_APP_CM_US}:${process.env.REACT_APP_CM_PD}`)
  },
}

export const  validateSomaliaPhoneNumber =(phoneNumber) => {
  const cleanedNumber = phoneNumber.replace(/\D/g, '');
  const somaliaPhonePattern = /^(?:\+252|0)?[0-9]\d{7}$/;
  return somaliaPhonePattern.test(cleanedNumber);
}
export const fno = (phoneNumber)=> {
  //const cleanedNumber = phoneNumber.replace(/\D/g, '')
  const pattern = /^\+252\d{9}$/;
  return pattern.test(phoneNumber);
}

export const TOAST_OPTIONS = {
    preventDuplicates: true,
    positionClass: "toast-top-center",
    closeButton: true,
    progressBar: true,
    progressAnimation: 'increasing',
    newestOnTop: true,
    autoClose: 5000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}
export const formatDate = date => {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}
export const formatDate2 = date => {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [day, month, year].join('/');
}

export const yearsPast = (initialDate) => { 
  if(initialDate != '0001-01-01'){
    var years = Math.abs(new Date(new Date() - new Date(initialDate)).getUTCFullYear() - 1970);
    return years;
  }else{
    return '-'
  }
}